import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";

// TanStack Start's own entry, except that the server's page paints first. The scripts are already
// loaded when the parser reaches them, so hydrating at once held the first paint back by 80 to
// 120 ms. The first frame is after the next animation frame; a hidden page has none to wait for.
function afterFirstPaint(run: () => void) {
  if (document.visibilityState === "hidden") run();
  else requestAnimationFrame(() => setTimeout(run, 0));
}

afterFirstPaint(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <StartClient />
      </StrictMode>,
    );
  });
});
